import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { ReactReader } from "react-reader";
import { Document,Page,pdfjs} from 'react-pdf';

//j'ai copié dans public la version pdf.worker.min.mjs obtenu dans node modules 
pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.mjs`;

interface IProps {
  show: boolean;
  handleClose: () => void;
  //base 64
  urlToRead: string;
  headerText: string|undefined;
}
const ModalReader: React.FC<IProps> = ({
  show,
  handleClose,
  urlToRead,
  headerText,
}) => {
  
  const [location, setLocation] = useState<string | number>(0);
  const epubRender = (
    <div style={{ height: '80vh',width:'60vh',display: 'table-cell' }}>
    <ReactReader
      url={urlToRead}
      location={location}
      locationChanged={(epubcfi: string) => setLocation(epubcfi)}
    />
    </div>
  );

  // console.log("pdfWorker:",new URL("pdfjs-dist/build/pdf.worker.min.mjs", window.location.origin).toString());
  // console.log("pdfWorker2:",`${process.env.PUBLIC_URL}/pdf.worker.min.mjs`);
  
  const [numPages, setNumPages] = useState<number>(1);
  const [pageNumber, setPageNumber] = useState<number>(1);

  function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
    setNumPages(numPages);
  }

  const pdfRender = (
    <div>
      {/* <style>
        {`
          .react-pdf__Page__annotations {
            display: none;
          }
          .react-pdf__Page__textContent {
            display: none;
          }
          .react-pdf__Page__canvas {
            display: block;
          }
        `}
      </style> */}
      <Document file={urlToRead} onLoadSuccess={onDocumentLoadSuccess} renderMode="canvas">
        <Page pageNumber={pageNumber} renderTextLayer={false} renderAnnotationLayer={false} />
      </Document>
      <p>
        Page {pageNumber} sur {numPages}
      </p>
      <div>
        <button
          type="button"
          className="btn btn-primary"
          disabled={pageNumber <= 1}
          onClick={() => setPageNumber(pageNumber - 1)}
        >
          Précédente
        </button>
        <button
          type="button"
          className="btn btn-secondary"
          disabled={pageNumber >= numPages}
          onClick={() => setPageNumber(pageNumber + 1)}
        >
          Suivante
        </button>
      </div>
    </div>
  );

  return (
    <Modal show={show} onHide={handleClose} >
      <Modal.Header closeButton>
        <p className="fw-bold">{headerText}</p>
      </Modal.Header>
      <Modal.Body>
        {urlToRead.toLowerCase().includes(".epub") && epubRender}
        {urlToRead.toLowerCase().includes(".pdf") && pdfRender}
        {!urlToRead.toLowerCase().includes(".epub") && !urlToRead.toLowerCase().includes(".pdf") && <>Format inconnu</>}
      </Modal.Body>
    </Modal>
  );
};

export default ModalReader;
